import { Box, Button, Stack, Typography } from "@mui/material";
import { Player } from "../api/types.tsx";

interface PlayerToolbarProps {
    players: Player[];
    selectedIds: number[];
    onSelectAll: () => void;
    onDeselectAll: () => void;
    onCompare: () => void;
}

export function PlayerToolbar({ players, selectedIds, onSelectAll, onDeselectAll, onCompare }: PlayerToolbarProps) {
    return (
        <Box mb={2} display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2}>
            <Typography variant="subtitle2">
                Selezionati: <strong>{selectedIds.length}</strong> / {players.length}
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap">
                <Button variant="outlined" size="small" onClick={onCompare} disabled={selectedIds.length < 2}>
                    Confronta
                </Button>
                <Button variant="outlined" size="small" onClick={onSelectAll}>
                    Seleziona tutti
                </Button>
                <Button variant="outlined" size="small" onClick={onDeselectAll}>
                    Deseleziona
                </Button>
            </Stack>
        </Box>
    );
}
